export enum LocalStorageKeys {
    User = 'user',
    Token = 'token',
    TwoFactorChallenge = '2fa_challenge',
}